<div class="remove-user-modal">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.Term, langText.AreYouSure)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body pt-0">
    <p class="mb-4">{{localize(langSection.RemoveUserModal, langText.RemoveUser)}}</p>
    <p class="preserve-white-space"><strong>{{localize(langSection.Term, langText.User)}}:</strong> {{user.upsId}} ({{user.email}})</p>
    <p><strong>{{localize(langSection.Term, langText.Locations)}}:</strong> {{user.locations.length}}</p>
  </div>
  <div class="modal-footer">
    @if (saveFailed) {
<span class="error">{{localize(langSection.RemoveUserModal, langText.SaveFailed)}}</span>
}
    <div>
      <button type="button" class="btn btn-green" (click)="removeUserFromAllLocations()">{{localize(langSection.Term, langText.Yes)}}</button>
      <button type="button" class="btn btn-white" (click)="dismissModal()">{{localize(langSection.Term, langText.No)}}</button>
    </div>
  </div>
</div>